import { render, staticRenderFns } from "./LinkToSale.vue?vue&type=template&id=755b6a8e&scoped=true"
import script from "./LinkToSale.vue?vue&type=script&lang=js"
export * from "./LinkToSale.vue?vue&type=script&lang=js"
import style0 from "./LinkToSale.vue?vue&type=style&index=0&id=755b6a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755b6a8e",
  null
  
)

export default component.exports